"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./comps/index");
exports.OsmosysUi = index_1.OsmosysUi;
// import { createOsmosysLogger } from '@osmosys/utils';
// import React from 'react';
// import ReactDOM from 'react-dom';
// import { AppOuter } from './comps/AppOuter';
// if (process.env.NODE_ENV !== 'production') {
//   // eslint-disable-next-line @typescript-eslint/no-var-requires
//   const whyDidYouRender = require('@welldone-software/why-did-you-render');
//   whyDidYouRender(React);
// }
// const logger = createOsmosysLogger({
//   module: 'website',
//   subModule: 'App',
// });
// // NEEDED FOR OAUTH (MAILCHIMP ONLY SUPPORTS REDIRECTS TO 127.0.0.1, NOT LOCALHOST)
// logger.info('RENDERING OSMOSYS...');
// ReactDOM.render(<AppOuter />, document.getElementById('root'));
// // ReactDOM.render(<AppOuter />, document.getElementById('root'));
// if (module.hot) {
//   logger.info('WAITING FOR HOT CHANGES...');
//   module.hot.accept('./comps/App', () => {
//     // eslint-disable-next-line @typescript-eslint/no-var-requires
//     const NextAppOuter = require('./comps/AppOuter');
//     logger.info('ACCEPTED HOT CHANGE. RENDERING OSMOSYS...');
//     ReactDOM.render(<NextAppOuter />, document.getElementById('root'));
//   });
// }
//# sourceMappingURL=index.js.map